import {useParams } from 'react-router-dom';
import useFetch from '../useFetch';
import {format} from 'date-fns'
import CustomError from '../CustomError';

const InvoiceDetails = (props) => {    
    const {id} = useParams(); 
    const {data:item, error} = useFetch(`https://api.plusat.be/invoices/${id}`);
    
    return (        
        <div className="details">     
        <br />   
        {item &&
            <fieldset className="details-panel">
            <legend>Details:</legend>
            <label >Invoice number: &nbsp;</label><input type="text" value={item.invoiceNo} readOnly/><br />
            <label >Invoice date: &nbsp;</label><input type="text" value={format(new Date(item.invoiceDate), "MMMM dd, yyyy")} readOnly/><br />
            <label >Client: &nbsp;</label><input type="text" value={item.invoiceClient} readOnly/><br />
            <label >Amount: &nbsp;</label><input type="text" value={item.invoiceAmount} readOnly/>
            </fieldset>
        }

        {error && <CustomError error={error}/>}
        </div>
    );
}

export default InvoiceDetails;